import { type ReactNode } from 'react';
import useStyles from './DayContainer.styles';
import { Paper } from '@mui/material';
import CalendarUtils from 'utils/calendar';
import { useCalendarContext } from 'components/features/Calendar';

type DayContainerProps = {
  children: ReactNode;
};

const DayContainer = ({ children }: DayContainerProps): JSX.Element | null => {
  const { selectedDate } = useCalendarContext();
  const classes = useStyles();

  if (!selectedDate) {
    return null;
  }

  const selectedDateLabel =
    CalendarUtils.formatDateToDayFullMonthAndYearString(selectedDate);

  return (
    <Paper className={classes.dayContentContainer}>
      <div className={classes.day}>{selectedDateLabel}</div>
      {children}
    </Paper>
  );
};

export default DayContainer;
